<template>
  <div class="error">
    <h1 class="error__message" data-test-selector="error-message">
      {{ $t('welcome.notFound') }}
    </h1>
    <common-button
      id="login-button"
      data-test-selector="login-button"
      primary
      @click.prevent="goHome"
    >
      {{ $t('welcome.notFoundButton') }}
    </common-button>
  </div>
</template>

<script>
import { ROUTES } from '../constants';
import CommonButton from '@/components/common/CommonButton';

export default {
  name: 'Page404',
  components: {
    CommonButton,
  },
  methods: {
    goHome() {
      this.$router.push(ROUTES.HOME);
    },
  },
};
</script>

<style scoped lang="scss">
@import '../scss/variables';
.error {
  color: #070707;
  font-family: Avenir;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  &__message {
    font-size: 48px;
    margin-bottom: 15px;
    display: block;
  }
}
#login-button {
  margin: 40px 0 30px;
}
</style>



// WEBPACK FOOTER //
// src/pages/Page404.vue